const PAYER_TYPE = {
  LANDLORD: "landlord",
  RENTER: "renter",
}

export default PAYER_TYPE
